import axios from 'axios';

const baseUrl =
  process.env.NODE_ENV === 'development' ? 'https://m.hangongyun.com' : '/';

// 配置新建一个 axios 实例
const service = axios.create({
  baseURL: baseUrl,
  timeout: 50000
});


// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    console.log("---------------------------=====",config)
    const params = new URLSearchParams()
    for (const key in config.data) {
      if (config.data.hasOwnProperty(key)) {
        params.append(key, config.data[key])
      }
    }
    config.data = params
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);


// 导出 axios 实例
export default service;



// WEBPACK FOOTER //
// ./src/api/request.js